export default __webpack_public_path__ + "static/media/1g.2bffde4c.svg";